/**
 * Cleans the image url for proper display.
 * @param  {string} thumbnailUrl url of the thumbnail
 * @return {string}              Absolute path to the image based on the server path.
 */
// eslint-disable-next-line
export const cleanImageUrl = (thumbnailUrl) => {
  if (thumbnailUrl) {
    if (thumbnailUrl.includes('http://')) {
      return thumbnailUrl;
    }
    return `http://${window.location.hostname}/${thumbnailUrl}`;
  }
  return thumbnailUrl;
};



// WEBPACK FOOTER //
// ./app/util/urlUtils.js